import React, { useRef, useState, useEffect } from "react";
import { TextInput, Checkbox } from "../../form/inputs";
import UploadTriggerCard from "../../upload/UploadTriggerCard";
import GalleryImg from "../../../assets/images/svgs/other/uploadImg.svg";
import UploadIcon from "../../../assets/images/svgs/other/Uploadicon.svg";
import { Tooltip } from "react-tooltip";
import { CiCircleInfo } from "react-icons/ci";
import { GoSun } from "react-icons/go";
import { BsMoonStars } from "react-icons/bs";
import ToggleBtn from "../../button/ToggleBtn";
import { MdDeleteOutline, MdAdd } from "react-icons/md";
import MealUploadLibraryModal from "../../Modals/MealUploadLibraryModal";
import SortableImageItem from "../../upload/SortablleImageItem";
import { useDispatch, useSelector } from "react-redux";
import ExtraItemsModalShimmer from "../../Preloader/ExtraItemsModalShimmer";
import PrimaryBtn from "../../button/PrimaryBtn";
import Cropper from "react-easy-crop";
import TimeRangePicker12 from "../../ui/TimeRangePicker12";
import {
  getExtraItems,
  isExtraItemChecked,
  addNewExtraItem,
  addNewImages,
  addOrUpdateMealDetail,
  getAllMeals,
} from "../../../redux/thunks/mealsetupThunk";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import toast from "react-hot-toast";
import Cropimage, { generateFileName } from "../../../utils/Cropimage";
import { useNavigate } from "react-router-dom";

const Mealplan = ({
  varient,
  setTab,
  setScreen = () => {},
  isSetupFlow = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isMealLoading, mealErr } = useSelector((state) => state.setMeal);
  const [showUploadOptions, setShowUploadOptions] = useState(false);
  const [showLibrary, setShowLibrary] = useState(false);
  const fileInputRef = useRef(null);
  const [showAddInline, setShowAddInline] = useState(false);
  const [extraItemName, setExtraItemName] = useState("");
  const [extraItemAmount, setExtraItemAmount] = useState("");
  const [removedImages, setRemovedImages] = useState([]);
  // Meal basic info
  const [meal_name, setMealName] = useState("");
  const [meal_description, setMealDescription] = useState("");
  const [trial_serving_cost, setTrialServingCost] = useState("");
  const [errors, setErrors] = useState({});

  // Cutoff times
  const [lunch_cutoff_time, setLunchCutoffTime] = useState("");
  const [dinner_cutoff_time, setDinnerCutoffTime] = useState("");

  // For image crop feature
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [showCrop, setShowCrop] = useState("");
  const [imageForCrop, setImageForCrop] = useState(null);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const currencySymbol = localStorage.getItem("currency");
  const onCropComplete = (croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  };

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [dayToggle, setDayToggle] = useState(
    days.reduce((acc, day) => ({ ...acc, [day]: false }), {}),
  );

  const [foodType, setFoodType] = useState(
    days.reduce(
      (acc, day) => ({ ...acc, [day]: { lunch: false, dinner: false } }),
      {},
    ),
  );

  const [serviceImages, setServiceImages] = useState([]);

  useEffect(() => {
    return () => {
      serviceImages.forEach((img) => {
        if (img.type === "upload" && img.preview) {
          URL.revokeObjectURL(img.preview);
        }
      });
    };
  }, [serviceImages]);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, {
      activationConstraint: { delay: 200, tolerance: 5 },
    }),
  );

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setServiceImages((prev) => {
      const draggedIndex = prev.findIndex((img) => img.id === active.id);
      const overIndex = prev.findIndex((img) => img.id === over.id);

      // Make a copy of the array
      const newArr = [...prev];

      // Remove the dragged item
      const [dragged] = newArr.splice(draggedIndex, 1);

      // Insert it at the new position
      newArr.splice(overIndex, 0, dragged);

      // Ensure the first image is always marked as cover
      newArr.forEach((img, index) => {
        img.isCover = index === 0;
      });

      return newArr;
    });
  };

  const handleDeviceUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const MAX_IMAGES = 10;
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    const allowedExtensions = ["jpg", "jpeg", "png", "webp"];

    // 🔥 Image count validation
    if (serviceImages.length + files.length > MAX_IMAGES) {
      toast.error("Maximum 10 images allowed");
      e.target.value = "";
      return;
    }

    files.forEach((file) => {
      const extension = file.name.split(".").pop().toLowerCase();

      // ✅ Extension validation
      if (!allowedExtensions.includes(extension)) {
        toast.error(
          `${file.name} not supported. Only JPG, JPEG, PNG, WEBP allowed`,
        );
        return;
      }

      // ✅ Size validation
      if (file.size > MAX_SIZE) {
        toast.error(`${file.name} exceeds 5MB limit`);
        return;
      }

      const url = URL.createObjectURL(file);
      setImageForCrop({ file, url });
      setShowCrop(true);
    });

    if (!files) return;

    // Must be a valid File
    if (!(files instanceof File)) {
      console.error("Selected item is not a file:", files);
      return;
    }

    // Create object URL for cropper preview
    const url = URL.createObjectURL(files);

    setImageForCrop({ files, url });
    setShowCrop(true);

    e.target.value = ""; // reset input
  };

  const buildAvailabilityData = () => {
    return days.map((day) => {
      const active = dayToggle[day];

      return {
        key: day.toLowerCase().trim(),
        isActive: active,
        isLunch: active ? foodType[day]?.lunch || false : false,
        isDinner: active ? foodType[day]?.dinner || false : false,
      };
    });
    label = "Meal Name";
  };

  const validateMeal = () => {
    const newErrors = {};

    if (!meal_name?.trim()) newErrors.meal_name = "Meal Name is required";
    if (!meal_description?.trim())
      newErrors.meal_description = "Meal Description is required";
    if (!trial_serving_cost)
      newErrors.trial_serving_cost = "Trial cost is required";
    if (!lunch_cutoff_time) newErrors.lunch_cutoff_time = "Lunch time required";
    if (!dinner_cutoff_time)
      newErrors.dinner_cutoff_time = "Dinner time required";
    if (!serviceImages.length)
      newErrors.serviceImages = "At least one image is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const convertTo24Hour = (timeObj) => {
    if (!timeObj || !timeObj.hour || !timeObj.minute) return "";

    let hour = parseInt(timeObj.hour, 10);
    let minute = parseInt(timeObj.minute, 10);
    const period = timeObj.period;

    if (period === "PM" && hour !== 12) hour += 12;
    if (period === "AM" && hour === 12) hour = 0;

    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
  };

  const convertTo12HourObject = (timeStr) => {
    if (!timeStr) return null;

    const [hourStr, minute] = timeStr.split(":");
    let hour = parseInt(hourStr, 10);
    let period = "AM";

    if (hour >= 12) {
      period = "PM";
      if (hour > 12) hour -= 12;
    }

    if (hour === 0) {
      hour = 12;
    }

    return {
      hour: String(hour).padStart(2, "0"),
      minute,
      period,
    };
  };

  const handleOnMealSave = async () => {
    if (!validateMeal()) {
      return;
    }

    try {
      // ================= UPLOAD ALL IMAGES =================
      const uploadableImages = serviceImages.filter(
        (img) => img.type === "upload" && img.file,
      );

      let uploadedNames = [];

      if (uploadableImages.length > 0) {
        const fd = new FormData();
        fd.append("type", "meals/other_images");
        uploadableImages.forEach((img) => fd.append("images[]", img.file));

        const uploadRes = await dispatch(addNewImages(fd)).unwrap();
        if (!uploadRes.success) {
          toast.error(uploadRes.message || "Image upload failed");
          return;
        }
        uploadedNames = uploadRes?.data?.temp_images || [];
        // console.log("All uploaded images:", uploadedNames);
      }

      // ================= BUILD COVER IMAGE =================
      const firstImage = serviceImages[0];
      // console.log("The first Image is :", firstImage);
      let meal_cover_images = null;

      if (firstImage.type === "gallery") {
        meal_cover_images = {
          type: "gallery",
          id: firstImage.imageId,
          name: firstImage.name || "",
        };
      } else if (firstImage.type === "upload") {
        const coverName = uploadedNames[0];
        if (!coverName) {
          toast.error("Cover image upload failed");
          return;
        }
        meal_cover_images = { type: "upload", name: coverName };
      }

      // ================= BUILD OTHER IMAGES =================
      const meal_other_images = serviceImages
        .slice(1)
        .map((img, index) => {
          if (img.type === "gallery")
            return { type: "gallery", id: img.imageId, name: img.name };
          if (img.type === "upload") return { type: "upload", name: img.name }; // index+1 because 0th is cover
          return null;
        })
        .filter(Boolean);

      // ================= REMOVED IMAGES =================
      const removed_other_images = removedImages
        .map((img) => {
          if (!img.name && !img.imageId) return null;
          return {
            type: img.type,
            id: img.imageId || undefined,
            name: img.name,
          };
        })
        .filter(Boolean);

      // ================= PLANS & EXTRA ITEMS =================
      const weekly_plans = weekly
        .filter((w) => w.price && w.days)
        .map((w) => ({
          order_count: Number(w.days),
          plan_amount: Number(w.price),
        }));

      const monthly_plans = monthly
        .filter((m) => m.price && m.days)
        .map((m) => ({
          order_count: Number(m.days),
          plan_amount: Number(m.price),
        }));

      const extra_item_ids = extraItems
        .filter((i) => i.selected)
        .map((i) => Number(i.id))
        .filter((id) => !isNaN(id));

      // ================= FINAL PAYLOAD =================
      const payload = {
        meal_name: meal_name,
        meal_description: meal_description,
        trial_serving_cost: Number(trial_serving_cost),
        availability_data: buildAvailabilityData(),
        lunch_cutoff_time: convertTo24Hour(lunch_cutoff_time),
        dinner_cutoff_time: convertTo24Hour(dinner_cutoff_time),
        weekly_plans: weekly_plans,
        monthly_plans: monthly_plans,
        meal_cover_images: meal_cover_images,
        meal_other_images: meal_other_images,
        removed_other_images,
        extra_item_ids,
      };

      console.log("🔥 FINAL PAYLOAD:", payload);

      const res = await dispatch(addOrUpdateMealDetail(payload)).unwrap();
      if (!res.success) {
        toast.error(res.message || "Meal not saved");
        return;
      }

      toast.success(res.message || "Meal saved successfully");

      if (varient === "profile") {
        navigate("/profile/meals");
      } else {
        setScreen("MEAL_EXTERNAL");
      }
    } catch (err) {
      const msg =
        typeof err === "string"
          ? err
          : err?.message || err?.data?.message || "Something went wrong";
      toast.error(msg);
      // console.log("The error is:", err);
    }
  };
  // useEffect(() => {
  //   console.log("The service images are :", serviceImages);
  // }, []);
  useEffect(() => {
    dispatch(getExtraItems())
      .unwrap()
      .then((res) => {
        const extraItemData = res.data.extra_items;

        const formatted = extraItemData.map((item) => ({
          id: item.id,
          name: item.name,
          price: item.amounts,
          selected: false,
        }));

        setExtraItems(formatted);
      });
  }, [dispatch]);

  // const handleExtraToggle = (item) => {
  //   setExtraItems((prev) =>
  //     prev.map((el) =>
  //       el.id === item.id ? { ...el, selected: !el.selected } : el,
  //     ),
  //   );

  //   // Optional: send API update in background
  //   const payload = {
  //     extra_item_id: item.id,
  //     is_confirmed: 1,
  //   };
  //   dispatch(isExtraItemChecked(payload)).catch(console.error);
  // };

  const handleAddNewExtra = async () => {
    if (!newExtra.name || !newExtra.price) return;

    const tempId = crypto.randomUUID();

    const newItem = {
      id: tempId,
      name: newExtra.name,
      price: newExtra.price,
      selected: true,
    };

    setExtraItems((prev) => [...prev, newItem]);

    setNewExtra({ name: "", price: "" });

    try {
      const payload = {
        name: newItem.name,
        amounts: newItem.price,
      };

      const res = await dispatch(addNewExtraItem(payload)).unwrap();
      setShowAddInline(false);
      if (res.success) {
        setExtraItems((prev) =>
          prev.map((item) =>
            item.id === tempId ? { ...item, id: res.data.id } : item,
          ),
        );
      }
    } catch (err) {
      toast.error("Failed to save extra item");
    }
  };

  // Extra Items
  const [extraItems, setExtraItems] = useState([]);
  const [newExtra, setNewExtra] = useState({ name: "", price: "" });
  const [showExtraModal, setShowExtraModal] = useState(false);

  const [weekly, setWeekly] = useState([{ price: "", days: "" }]);
  const [monthly, setMonthly] = useState([{ price: "", days: "" }]);

  const closeModal = () => {
    setShowExtraModal(false);
    setShowAddInline(false);
    setNewExtra({ name: "", price: "" });
  };
  const deleteExtraItem = (id) => {
    setExtraItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, selected: false } : item,
      ),
    );
  };
  const addWeekly = () => {
    setWeekly((prev) => [...prev, { price: "", days: "" }]);
  };

  const deleteWeekly = (index) => {
    setWeekly((prev) => prev.filter((_, i) => i !== index));
  };

  const addMonthly = () => {
    setMonthly((prev) => [...prev, { price: "", days: "" }]);
  };

  const deleteMonthly = (index) => {
    setMonthly((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (imageForCrop?.url) {
      setCrop({ x: 0, y: 0 });
      setZoom(1);
    }
  }, [imageForCrop]);

  return (
    <>
      <div className="bg-white py-8 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* ================= Title ================= */}
          {varient === "profile" ? (
            ""
          ) : (
            <>
              <div className="text-center space-y-2 max-w-2xl mx-auto">
                <h1 className="text-[#191919] text-2xl md:text-3xl font-bold">
                  Set Up Meal Plans
                </h1>
                <p className="text-gray-600 text-base">
                  Add meal plans, their timing, and costing that match the
                  quality of your tiffins.
                </p>
              </div>
            </>
          )}

          {/* ================= Meal Name ================= */}
          <div className="max-w-7xl mx-auto">
            <TextInput
              label="Meal Name"
              required={true}
              name="mealname"
              placeholder="Enter Meal Name"
              value={meal_name} // ✅ bind state
              onChange={(e) => {
                setMealName(e.target.value);
                setErrors((prev) => ({ ...prev, meal_name: "" }));
              }}
            />
            {errors.meal_name && (
              <p className="text-sm text-red-500 mt-1">{errors.meal_name}</p>
            )}
          </div>

          {/* ================= Upload Meal Photo ================= */}
          <div className="max-w-7xl mx-auto space-y-2">
            <p className="text-sm font-medium text-gray-700">
              Upload Meal Photograph{" "}
              <span className="text-xs text-red-500">*</span>
            </p>
            <UploadTriggerCard
              required={true}
              icon={GalleryImg}
              text="Upload your meal photo or brand image"
              buttonText="Upload"
              onClick={() => setShowUploadOptions(true)}
            />

            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleDeviceUpload}
            />
            {errors.serviceImages && (
              <p className="text-sm text-red-500 mt-1">
                {errors.serviceImages}
              </p>
            )}
          </div>

          {/* ================= Images Preview ================= */}
          {serviceImages.length > 0 && (
            <div className="max-w-6xl mx-auto">
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
              >
                <SortableContext
                  items={serviceImages.map((i) => i.id)}
                  strategy={rectSortingStrategy}
                >
                  <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-4 touch-none">
                    {serviceImages.map((item, i) => (
                      <SortableImageItem
                        key={item.id}
                        id={item.id}
                        img={item}
                        isCover={i === 0}
                        onRemove={() => {
                          setServiceImages((prev) => {
                            const removed = prev[i];
                            if (removed) {
                              setRemovedImages((old) => [
                                ...old,
                                {
                                  type: removed.type || "upload",
                                  imageId: removed.imageId,
                                  name: removed.name,
                                },
                              ]);
                            }

                            return prev.filter((_, idx) => idx !== i);
                          });
                        }}
                      />
                    ))}
                  </div>
                </SortableContext>
              </DndContext>

              <p className="mt-3 text-sm text-gray-600">
                Note: The first image will appear as your cover image.You can
                click and hold to drag images and change their order.
              </p>
            </div>
          )}

          {/* ================= Meal Description ================= */}
          <div className="max-w-7xl mx-auto">
            <TextInput
              required={true}
              label="Meal Description"
              name="description"
              placeholder="Enter Description"
              value={meal_description}
              onChange={(e) => {
                setMealDescription(e.target.value);
                setErrors((prev) => ({ ...prev, meal_description: "" }));
              }}
            />
            {errors.meal_description && (
              <p className="text-sm text-red-500 mt-1">
                {errors.meal_description}
              </p>
            )}
          </div>

          {/* ================= Days & Meal Types ================= */}
          <div className="max-w-7xl mx-auto space-y-6">
            <div className="flex gap-2 items-center mb-2">
              <p className="font-medium text-sm text-gray-700">
                Choose Service Days and Timings{" "}
                <span className="text-red-500 ml-1">*</span>{" "}
              </p>
              <CiCircleInfo
                size={18}
                className="cursor-pointer text-gray-400"
                data-tooltip-id="desc-info"
                data-tooltip-content="Select the days and meal types available for your customers. At least selecting 3 days is compulsory"
              />
              <Tooltip
                id="desc-info"
                place="top"
                className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[240px] text-center"
              />
            </div>

            {days.map((day) => (
              <div
                key={day}
                className="flex flex-nowrap items-center justify-between md:justify-start bg-gray-50 rounded-lg gap-0 md:gap-4"
              >
                <div>
                  <p className="w-16 text-sm">{day}</p>
                </div>

                {/* 3️⃣ Disable checkboxes if toggle is off */}
                <div className="flex gap-2 items-center justify-end flex-wrap">
                  <ToggleBtn
                    isOn={dayToggle[day]}
                    size={40}
                    onChange={() => {
                      setDayToggle((prev) => {
                        const newValue = !prev[day];

                        setFoodType((ft) => ({
                          ...ft,
                          [day]: newValue
                            ? { lunch: true, dinner: true } // ✅ toggle ON → default checked
                            : { lunch: false, dinner: false }, // ❌ toggle OFF → reset
                        }));

                        return { ...prev, [day]: newValue };
                      });
                    }}
                  />

                  <Checkbox
                    variant="pill"
                    label="Lunch"
                    name={`lunch-${day}`}
                    icon={<GoSun />}
                    checked={foodType[day].lunch}
                    disabled={!dayToggle[day]}
                    onChange={(e) =>
                      setFoodType((prev) => ({
                        ...prev,
                        [day]: { ...prev[day], lunch: e.target.checked },
                      }))
                    }
                    extraClass="bg-[#B472FF]"
                  />

                  <Checkbox
                    variant="pill"
                    label="Dinner"
                    name={`dinner-${day}`}
                    icon={<BsMoonStars />}
                    checked={foodType[day].dinner}
                    disabled={!dayToggle[day]}
                    onChange={(e) =>
                      setFoodType((prev) => ({
                        ...prev,
                        [day]: { ...prev[day], dinner: e.target.checked },
                      }))
                    }
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="max-w-7xl mx-auto overflow-hidden">
            <p className="font-medium text-gray-700 text-sm">
              Meal plan pricing{" "}
              <span className="text-red-500 ml-1">*</span>{" "}
            </p>
            <fieldset className="border rounded-xl p-4 overflow-hidden mt-4">
              <legend className="px-2 text-sm text-gray-700">
                Trial (1 Meal)
              </legend>

              <div className="space-y-2">
                <p className="text-sm text-gray-600">Price</p>

                {/* ONE ROW – NO SIDE SCROLL */}
                <div className="flex items-center gap-2 flex-nowrap rounded-lg w-full">
                  {/* $ */}
                  <div className="px-3 py-1.5 rounded-md border border-gray-100 bg-red-50 text-red-500 font-medium border-r shrink-0">
                    {currencySymbol}
                  </div>

                  {/* INPUT */}
                  <input
                    type="text"
                    value={trial_serving_cost}
                    placeholder="Price"
                    onChange={(e) => {
                      const value = e.target.value;

                      // Allow numbers with optional decimal
                      if (/^\d*\.?\d*$/.test(value)) {
                        setTrialServingCost(value);

                        setErrors((prev) => ({
                          ...prev,
                          trial_serving_cost: "",
                        }));
                      }
                    }}
                    className="flex-1 min-w-0 px-2 py-2 w-full rounded-md outline-none text-sm border border-gray-100"
                  />

                  {/* BADGE */}
                  <div className="px-2 py-1 mr-2 bg-red-50 text-red-500 text-[11px] rounded-full whitespace-nowrap shrink-0">
                    {currencySymbol}
                    {trial_serving_cost}/Order
                  </div>
                </div>
              </div>
            </fieldset>
            {errors.trial_serving_cost && (
              <p className="text-sm text-red-500 mt-1">
                {errors.trial_serving_cost}
              </p>
            )}
          </div>

          <div className="max-w-7xl mx-auto">
            <fieldset className="border rounded-2xl p-4 mt-4 bg-white">
              <legend className="px-3 text-sm font-medium text-gray-700">
                Weekly
              </legend>

              <div className="space-y-5">
                {weekly.map((item, index) => (
                  <div key={index} className="space-y-2">
                    {/* <p className="text-sm font-medium text-gray-600">Price</p> */}

                    {/* ROW */}
                    <div className="flex items-center gap-2 w-full border rounded-xl p-2 overflow-hidden">
                      {/* $ + Price */}
                      <div className="flex items-center gap-1 shrink-0">
                        <div className="px-3 py-1 bg-red-50 text-red-500 font-medium border rounded-md">
                          {currencySymbol}
                        </div>
                        <input
                          type="text"
                          placeholder="price"
                          value={item.price}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only numbers with optional decimal
                            if (/^\d*\.?\d*$/.test(value)) {
                              setWeekly((prev) =>
                                prev.map((w, i) =>
                                  i === index ? { ...w, price: value } : w,
                                ),
                              );
                            }
                          }}
                          className="w-12 sm:w-24 px-2 py-2 text-center text-sm border rounded-md"
                        />

                        {errors[`weekly_price_${index}`] && (
                          <p className="text-sm text-red-500 mt-1">
                            {errors[`weekly_price_${index}`]}
                          </p>
                        )}
                      </div>

                      {/* Days */}
                      <input
                        type="text"
                        value={item.days}
                        placeholder="days"
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers with optional decimal
                          if (/^\d*\.?\d*$/.test(value)) {
                            setWeekly((prev) =>
                              prev.map((w, i) =>
                                i === index
                                  ? { ...w, days: e.target.value }
                                  : w,
                              ),
                            );
                          }
                        }}
                        className="w-10 sm:w-20 px-2 py-2 text-center text-sm border rounded-md"
                      />
                      {errors[`weekly_days_${index}`] && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors[`weekly_days_${index}`]}
                        </p>
                      )}

                      <div className="flex-1 min-w-0 flex justify-center">
                        <span className="px-3 py-1 bg-red-50 text-red-500 text-xs font-medium rounded-full whitespace-nowrap">
                          {currencySymbol}
                          {item.price && item.days
                            ? (Number(item.price) / Number(item.days)).toFixed(
                                2,
                              )
                            : 0}{" "}
                          / Order
                        </span>
                      </div>

                      {/* Delete */}
                      <button
                        className="shrink-0 text-red-500"
                        onClick={() => deleteWeekly(index)}
                      >
                        <MdDeleteOutline size={22} />
                      </button>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={addWeekly}
                  className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
                >
                  <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                    <MdAdd size={15} />
                  </span>
                  Add more
                </button>

                <p className="text-[#242021] text-sm text-start max-w-7xl mx-auto">
                  Note: Add multiple weekly pricing options if your rates vary
                  by the number of days.
                </p>
              </div>
            </fieldset>
          </div>

          <div className="max-w-7xl mx-auto  ">
            <fieldset className="border rounded-2xl p-4 mt-4 bg-white">
              <legend className="px-3 text-sm font-medium text-gray-700">
                Monthly
              </legend>

              <div className="space-y-5">
                {monthly.map((item, index) => (
                  <div key={index} className="space-y-2">
                    {/* <p className="text-sm font-medium text-gray-600">Price</p> */}

                    {/* ROW */}
                    <div className="flex items-center gap-2 w-full border rounded-xl p-2 overflow-hidden">
                      {/* $ + Price */}
                      <div className="flex items-center gap-1 shrink-0">
                        <div className="px-3 py-1 bg-red-50 text-red-500 font-medium border rounded-md">
                          {currencySymbol}
                        </div>
                        <input
                          type="text"
                          placeholder="price"
                          value={item.price}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only numbers with optional decimal
                            if (/^\d*\.?\d*$/.test(value)) {
                              setMonthly((prev) =>
                                prev.map((w, i) =>
                                  i === index
                                    ? { ...w, price: e.target.value }
                                    : w,
                                ),
                              );
                            }
                          }}
                          className="w-12 sm:w-24 px-2 py-2 text-center text-sm border rounded-md"
                        />
                        {errors[`monthly_price_${index}`] && (
                          <p className="text-sm text-red-500 mt-1">
                            {errors[`monthly_price_${index}`]}
                          </p>
                        )}
                      </div>

                      {/* Days */}
                      <input
                        type="text"
                        placeholder="days"
                        value={item.days}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers with optional decimal
                          if (/^\d*\.?\d*$/.test(value)) {
                            setMonthly((prev) =>
                              prev.map((w, i) =>
                                i === index
                                  ? { ...w, days: e.target.value }
                                  : w,
                              ),
                            );
                          }
                        }}
                        className="w-10 sm:w-20 px-2 py-2 text-center text-sm border rounded-md"
                      />
                      {errors[`monthly_days_${index}`] && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors[`monthly_days_${index}`]}
                        </p>
                      )}

                      {/* Spacer (IMPORTANT for center alignment) */}
                      <div className="flex-1 min-w-0 flex justify-center">
                        <span className="px-3 py-1 bg-red-50 text-red-500 text-xs font-medium rounded-full whitespace-nowrap">
                          {currencySymbol}
                          {item.price && item.days
                            ? (Number(item.price) / Number(item.days)).toFixed(
                                2,
                              )
                            : 0}{" "}
                          / Order
                        </span>
                      </div>

                      {/* Delete */}
                      <button
                        className="shrink-0 text-red-500"
                        onClick={() => deleteMonthly(index)}
                      >
                        <MdDeleteOutline size={22} />
                      </button>
                    </div>
                  </div>
                ))}

                <button
                  type="button"
                  className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
                  onClick={addMonthly}
                >
                  <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                    <MdAdd size={15} />
                  </span>
                  Add more
                </button>
                <p className="text-[#242021] text-sm text-start max-w-7xl mx-auto">
                  Note: Add multiple Monthly pricing options if your rates vary
                  by the number of days.
                </p>
              </div>
            </fieldset>
          </div>

          <div className="max-w-7xl mx-auto">
            <div className="rounded-2xl bg-white p-2 md:p-6 shadow-sm border border-gray-100">
              {/* Header */}
              <div className="flex items-center gap-2 mb-6">
                <h2 className="text-lg font-semibold text-sm text-gray-700">
                  Cutoff Time <span className="text-red-500 ml-1">*</span>
                </h2>

                <CiCircleInfo
                  size={16}
                  className="text-gray-400 hover:text-[#FB6742] transition cursor-pointer"
                  data-tooltip-id="cutoff-info"
                  data-tooltip-content="Customers cannot place or cancel orders after this time."
                />

                <Tooltip
                  id="cutoff-info"
                  place="top"
                  className="!text-xs !bg-black !px-3 !py-2 !rounded-md !max-w-[220px] text-center"
                />
              </div>

              {/* Time Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <TimeRangePicker12
                  label="Lunch Cutoff"
                  variant="single"
                  value={lunch_cutoff_time || null}
                  onChange={(val) => {
                    setLunchCutoffTime(val);
                    setErrors((prev) => ({ ...prev, lunch_cutoff_time: "" }));
                  }}
                />

                <TimeRangePicker12
                  label="Dinner Cutoff"
                  variant="single"
                  value={dinner_cutoff_time || null}
                  onChange={(val) => {
                    setDinnerCutoffTime(val);
                    setErrors((prev) => ({
                      ...prev,
                      dinner_cutoff_time: "",
                    }));
                  }}
                />
              </div>
            </div>
          </div>

          <div className="max-w-7xl mx-auto overflow-hidden">
            <div className="flex gap-2 items-center mb-2">
              <p className="font-medium">Set extra items</p>
              <button
                onClick={() => setShowExtraModal(true)}
                className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
              >
                <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                  <MdAdd size={15} />
                </span>
                Add extra item
              </button>
            </div>

            <div className="space-y-2 mt-4">
              {extraItems.filter((item) => item.selected).length === 0 && (
                <p className="text-sm text-gray-400 text-center">
                  No extra items selected
                </p>
              )}

              {extraItems
                .filter((item) => item.selected)
                .map((item, index) => (
                  <div
                    key={item.id}
                    className={`flex items-center justify-between px-3 py-2 rounded-lg ${
                      index % 2 === 0 ? "bg-gray-50" : "bg-[#FFFAF8]"
                    }`}
                  >
                    <div className="text-sm font-medium">{item.name}</div>

                    <div className="flex gap-4 items-center">
                      <div className="px-2 py-1 text-[#FF6943] font-bold">
                        {currencySymbol}
                        {item.price}
                      </div>

                      <button
                        onClick={() => deleteExtraItem(item.id)}
                        className="text-[#FF6943]"
                      >
                        <MdDeleteOutline size={22} />
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="flex flex-col-reverse px-10 sm:flex-row sm:items-center md:justify-between gap-4 pt-6 mt-8 max-w-7xl mx-auto">
          {isSetupFlow && (
            <>
              <p
                onClick={() => setTab(2)}
                className="text-[#FF6943] text-sm text-center sm:text-right cursor-pointer hover:underline"
              >
                Skip
              </p>
            </>
          )}
          <PrimaryBtn
            btnName="Save"
            clickEvent={handleOnMealSave}
            extraClass="w-full px-10"
            isLoading={isMealLoading}
          />
        </div>
      </div>

      {/* ================= Upload Modal ================= */}
      {showUploadOptions && (
        <div className="fixed inset-0 bg-[#0F172A]/60 flex items-center justify-center z-50 animate-fadeIn">
          <div className="relative w-full max-w-lg mx-4">
            {/* Modal Card */}
            <div className="relative bg-white rounded-3xl p-8 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.25)] border border-gray-100">
              {/* Accent Top Bar */}

              {/* Title Section */}
              <div className="text-center mb-8">
                <h2 className="text-2xl font-semibold text-gray-700 tracking-tight">
                  Upload Photos
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                  Choose how you want to add your images
                </p>
              </div>

              {/* Options */}
              <div className="space-y-4">
                {/* Upload From Device */}
                <button
                  onClick={() => {
                    setShowUploadOptions(false);
                    fileInputRef.current.click();
                  }}
                  className="group relative w-full flex items-center justify-between px-6 py-5 rounded-2xl 
                             bg-gradient-to-r from-[#FF7043]/20 to-[#FF5722]/50 
                             text-white font-medium shadow-lg 
                             "
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/20">
                      <img
                        src={UploadIcon}
                        alt="uploadIcon"
                        className="w-6 h-6"
                      />
                    </div>
                    <span className="text-base text-black">
                      Upload from device
                    </span>
                  </div>

                  <span className="opacity-70 group-hover:translate-x-1 transition-transform duration-300">
                    →
                  </span>
                </button>

                {/* Choose From Library */}
                <button
                  onClick={() => {
                    setShowUploadOptions(false);
                    setShowLibrary(true);
                  }}
                  className="group w-full flex items-center justify-between px-6 py-5 rounded-2xl 
                             border border-gray-200 bg-white 
                             text-gray-700 font-medium 
                             "
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-100">
                      <img
                        src={GalleryImg}
                        alt="galleryicon"
                        className="w-6 h-6"
                      />
                    </div>
                    <span className="text-base">Choose from photo library</span>
                  </div>

                  <span className="text-gray-400 group-hover:translate-x-1 transition-transform duration-300">
                    →
                  </span>
                </button>
              </div>

              {/* Footer */}
              <div className="mt-8 text-center">
                <button
                  onClick={() => setShowUploadOptions(false)}
                  className="text-sm text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showCrop && imageForCrop && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl w-80 p-6 space-y-4">
            <h2 className="text-lg font-semibold text-center">Crop Image</h2>

            <div className="relative w-full h-64 bg-gray-100">
              <Cropper
                image={imageForCrop.url}
                crop={crop}
                zoom={zoom}
                aspect={4 / 3}
                cropShape="rect"
                showGrid={false}
                objectFit="horizontal-cover" // 🔥 IMPORTANT
                restrictPosition={false}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
            </div>
            <div className="mt-4">
              <input
                type="range"
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={(e) => setZoom(e.target.value)}
                className="w-full"
              />
            </div>

            <div className="flex justify-between mt-4">
              <button
                className="px-4 py-2 bg-gray-200 rounded"
                onClick={() => {
                  setShowCrop(false);
                  setImageForCrop(null);
                }}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 bg-[#FF6943] text-white rounded"
                onClick={async () => {
                  try {
                    const fileName = generateFileName(serviceImages.length);

                    const croppedFile = await Cropimage(
                      imageForCrop.url,
                      croppedAreaPixels,
                      fileName,
                    );

                    const previewUrl = URL.createObjectURL(croppedFile);

                    setServiceImages((prev) => [
                      ...prev,
                      {
                        id: crypto.randomUUID(),
                        preview: previewUrl, // ✅ UI ke liye
                        file: croppedFile, // ✅ API ke liye
                        name: fileName,
                        type: "upload",
                      },
                    ]);

                    setShowCrop(false);
                  } catch (err) {
                    console.error(err.message);
                  }
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}

      {showLibrary && (
        <MealUploadLibraryModal
          selectedImages={serviceImages
            .filter((img) => img.type === "gallery")
            .map((img) => img.imageId)}
          onClose={() => setShowLibrary(false)}
          onSelect={(selectedPhotos) => {
            const MAX_IMAGES = 10;

            setServiceImages((prev) => {
              const galleryImages = prev.filter(
                (img) => img.type === "gallery",
              );

              if (galleryImages.length >= MAX_IMAGES) {
                toast.error("Maximum 10 images allowed");
                return prev;
              }

              const existingIds = galleryImages.map((img) => img.imageId);

              const newImages = selectedPhotos
                .filter((img) => !existingIds.includes(img.id))
                .slice(0, MAX_IMAGES - galleryImages.length) // 🔥 prevent overflow
                .map((img) => ({
                  id: crypto.randomUUID(),
                  preview: img.image,
                  type: "gallery",
                  imageId: img.id,
                  name: img.image.split("/").pop(),
                }));

              return [...prev, ...newImages];
            });

            setShowLibrary(false);
          }}
        />
      )}

      {showExtraModal &&
        (isMealLoading ? (
          <ExtraItemsModalShimmer />
        ) : (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-xl w-full max-w-sm p-4 space-y-4 relative">
              {/* CLOSE BUTTON */}
              <button
                onClick={closeModal}
                className="absolute right-3 top-3 text-gray-500 hover:text-black text-lg"
              >
                ✕
              </button>

              <h2 className="text-lg font-semibold text-center">
                Add Extra Items
              </h2>

              {/* ITEMS LIST */}
              <div className="max-h-64 overflow-y-auto space-y-1">
                {extraItems.map((item, index) => (
                  <div
                    key={index}
                    className={`flex justify-between items-center px-3 py-2 rounded ${
                      index % 2 === 0 ? "bg-gray-50" : "bg-[#FFFAF8]"
                    }`}
                  >
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={item.selected || false}
                        onChange={() =>
                          setExtraItems((prev) =>
                            prev.map((el, i) =>
                              i === index
                                ? { ...el, selected: !el.selected }
                                : el,
                            ),
                          )
                        }
                        className="w-4 h-4 accent-green-500"
                      />

                      <span className="text-sm font-medium">{item.name}</span>
                    </div>

                    <span className="text-[#FF6943] font-bold text-sm">
                      {currencySymbol}
                      {item.price}
                    </span>
                  </div>
                ))}
              </div>

              {/* ADD NEW ITEM BUTTON */}
              {!showAddInline && (
                <p
                  className="text-xs text-center text-[#FF6943] cursor-pointer"
                  onClick={() => setShowAddInline(true)}
                >
                  Add New Extra Item
                </p>
              )}

              {/* ADD ITEM FORM */}
              {showAddInline && (
                <div className="flex gap-2 items-center mt-2">
                  <input
                    type="text"
                    placeholder="Item Name"
                    value={newExtra.name}
                    onChange={(e) =>
                      setNewExtra((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    className="flex-1 px-3 py-2 border rounded-md outline-none text-sm"
                  />

                  <div className="flex items-center border rounded-md px-2 py-1 text-sm">
                    {currencySymbol}
                    <input
                      type="number"
                      value={newExtra.price}
                      onChange={(e) =>
                        setNewExtra((prev) => ({
                          ...prev,
                          price: e.target.value,
                        }))
                      }
                      className="w-12 px-1 py-1 text-right outline-none"
                    />
                  </div>

                  <button
                    onClick={handleAddNewExtra}
                    className="bg-[#FF6943] text-white px-3 py-2 rounded-md"
                  >
                    +
                  </button>
                </div>
              )}

              {/* CONFIRM BUTTON */}
              <button
                onClick={closeModal}
                className="w-full bg-[#FF6943] text-white py-2 rounded-lg mt-2"
              >
                Add Items
              </button>
            </div>
          </div>
        ))}
    </>
  );
};

export default Mealplan;
